// <DatasetsSection
//             run={runWithDatasets.run}
//             title={'Input'}
//             datasets={runWithDatasets.input_datasets.map((i) => i.dataset)}
//           />

import { Stack, Text } from '@mantine/core';
import DatasetSidebarItem from '@/pages/Result/components/DatasetSidebarItem.tsx';
import { Run } from '@/types/runs.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  run: Run;
  title: string;
  datasets: Dataset[];
  addTab: (datasetId: string) => void;
};

const DatasetsSection = ({ run, title, datasets, addTab }: props) => {
  return (
    <Stack gap={'xs'} mb={'xs'}>
      <Text size={'11px'} fw={600} px={'xs'}>
        {title} ({datasets.length})
      </Text>
      <Stack gap={'2px'}>
        {datasets.map((dataset) => (
          <DatasetSidebarItem run={run} dataset={dataset} key={dataset.id} addTab={addTab} />
        ))}
      </Stack>
    </Stack>
  );
};

export default DatasetsSection;
